// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAlphaB = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M12.518 17H8.625V6.948h3.78c1.96 0 3.305.7 3.305 2.492 0 1.19-.603 1.946-1.429 2.296v.014c1.008.28 1.89.994 1.89 2.366 0 1.68-1.091 2.884-3.653 2.884m-.393-8.568h-1.791v2.716h1.792c1.274 0 1.82-.546 1.82-1.414 0-.84-.518-1.302-1.82-1.302m.14 4.13h-1.931v2.982h2.03c1.316 0 2.015-.518 2.015-1.568 0-.994-.727-1.414-2.113-1.414"
    />,
    <path
      fillRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1116 0 8 8 0 01-16 0"
    />
  );
export default SvgIconAlphaB;
